import * as React from 'react';
import { useSelector } from 'react-redux';
import { TAreaInputComponentProps } from 'shared/common/utils/types';
import { selectFormFields, selectEstimationTarget } from '../../selectors';
import { useActions } from '../useActions';
import { ECurrentErrorField, EUnits } from '../../types/formFields';
import { intOnly } from '../../utils/intOnly';
import { getTrackMyHomeAreaPick } from '../tracking';

/** Пропсы для фильтра площади дома */
export const useHouseAreaInputProps = (): TAreaInputComponentProps => {
  const { houseArea, errorTooltip, userSetArea } = useSelector(selectFormFields);
  const estimationTarget = useSelector(selectEstimationTarget);

  const { setError, setUserAreaFlag, setHouseArea } = useActions();

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.houseArea ? errorTooltip.errorText : '';

  /** Обработчик ввода в инпут Площади */
  const onValueChange = React.useCallback<TAreaInputComponentProps['onValueChange']>(
    value => {
      const intVal = intOnly(value);

      setHouseArea(Number(intVal));

      if (!userSetArea) {
        setUserAreaFlag(true);
      }

      if (errorMessage) {
        setError({ currentErrorField: ECurrentErrorField.houseArea, errorText: '' });
      }
    },
    [errorMessage, userSetArea, setHouseArea, setError, setUserAreaFlag],
  );

  return {
    value: houseArea ? String(houseArea) : '',
    unit: EUnits.area,
    shouldShowUnit: true,
    placeholder: '120',
    errorMessage,
    onValueChange,
    onBlur: getTrackMyHomeAreaPick({
      estimationTarget,
      value: Number(houseArea),
      auto: false,
    }),
  };
};
